import React, {useState} from 'react';
import VerticalStepper from "../components/VerticalStepper";
import Button from "@mui/material/Button";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import {componentMap} from "../assets/componentMap";

export const VerticalStepperWithContainer = () => {
    const [activeStep, setActiveStep] = useState(0);

    const [steps, setSteps] = useState(
        [
            {
                label: 'Thought',
                componentName: 'Thought',
                description: `For each ad campaign that you create, you can control how much
              you're willing to spend on clicks and conversions, which networks
              and geographical locations you want your ads to show on, and more.`,
                summary: '',
                thoughtScale: null,
                emotionScale: null,
            },
            {
                label: 'Emotion',
                componentName: 'Emotion',
                description:
                    'An ad group contains one or more ads which target a shared set of keywords.',
                summary: '',
                thoughtScale: null,
                emotionScale: null
            },
            {
                label: 'Situation',
                componentName: 'Situation',
                description: `Try out different ad text to see what brings in the most customers,
              and learn how to enhance your ads using features like ad extensions.
              If you run into any problems with your ads, find out how to tell if
              they're running and how to resolve approval issues.`,
                summary: '',
                thoughtScale: null,
                emotionScale: null
            },
            {
                label: 'Thinking Trap',
                componentName: 'ThinkingTraps',
                description: `Try out different ad text to see what brings in the most customers,
              and learn how to enhance your ads using features like ad extensions.
              If you run into any problems with your ads, find out how to tell if
              they're running and how to resolve approval issues.`,
                summary: '',
                thoughtScale: null,
                emotionScale: null
            },
            {
                label: 'Reframing',
                componentName: 'Reframe',
                description: `Try out different ad text to see what brings in the most customers,
              and learn how to enhance your ads using features like ad extensions.
              If you run into any problems with your ads, find out how to tell if
              they're running and how to resolve approval issues.`,
                summary: '',
                thoughtScale: null,
                emotionScale: null
            },
            {
                label: 'Survey',
                componentName: 'Survey',
                description: `Try out different ad text to see what brings in the most customers,
              and learn how to enhance your ads using features like ad extensions.
              If you run into any problems with your ads, find out how to tell if
              they're running and how to resolve approval issues.`,
                summary: '',
                thoughtScale: null,
                emotionScale: null
            }
        ]
    );

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
        setSteps(steps.map((step) => {return {...step, summary: ''}}));
    };

    const handleSetStepSummary = (obj) => {
        const tmpStepSummary = [...steps];
        tmpStepSummary[activeStep] = obj;
        setSteps(tmpStepSummary);
    };

    return (
        <div className="verticalStepperContainer" style={{display: "flex"}}>
            <div className="left-component">
                <VerticalStepper steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} />
                <div style={{display: "flex", flexDirection: "column-reverse", marginTop: "100px"}}>
                <Button style={{marginTop: "auto", alignSelf: "flex-start", alignItems: "center"}} variant="outlined" onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
                   <RestartAltIcon fontSize="small"/> Start Over
                </Button>
                </div>
            </div>
            <div className="right-component">
                {steps.map((step, index) => {
                    const Component = componentMap[step.componentName];
                    return index === activeStep && <Component key={index} step={step} steps={steps} handleNext={handleNext} handleBack={handleBack} activeStep={activeStep} handleSetStepSummary={handleSetStepSummary} />;
                })}
            </div>
        </div>
    )
}